import React from 'react';
export function Navigation() {
  return null;
}